import { toJS, observable, action } from "mobx";
import { httpClient } from "../../utils/httpClient";
import api from "../../config/api";
const { shop, operate, supplier } = api;

class ElebuysOperateStore {
  // 象买网-用户
  // 获取用户列表
  @observable userList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  @action async getUserList(params) {
    const { data } = await httpClient.post(operate.GET_ELEBUYS_USER_LIST, {
      ...params,
    });
    if (data) {
      this.userList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }
  @action async getEleStoresList(params) {
    const { data } = await httpClient.post(operate.GET_ELESTORES_USER_LIST, {
      ...params,
    });
    if (data) {
      this.userList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }

  // 获取认证审核列表
  @observable authList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  @action async getAuthList(params) {
    const { data } = await httpClient.post(operate.GET_ELEBUYS_AUTH_LIST, {
      ...params,
    });
    if (data) {
      this.authList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }

  // 获取注册审核列表
  @observable registerList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  @action async getRegisterList(params) {
    const { data } = await httpClient.post(
      operate.GET_ELEBUYS_USER_REGISTER_LIST,
      { ...params }
    );
    if (data) {
      this.registerList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }

  @action auditRegister(params) {
    return httpClient.post(operate.AUDIT_ELEBUYS_USER_REGISTER, { ...params });
  }

  @action auditAuth(params) {
    return httpClient.post(operate.AUDIT_ELEBUYS_AUTH, { ...params });
  }

  @action async getSupplierInfo(params) {
    const data = await httpClient.get(operate.GET_SUPPLIER_INFO, { params });
    return data;
  }

  @observable authInfo = {};
  @action async getAuthInfo(params) {
    const { data } = await httpClient.get(operate.GET_ELEBUYS_AUTH_INFO, {
      params,
    });
    if (data) {
      this.authInfo = data;
    }
  }

  @action editUser(params) {
    return httpClient.post(operate.EDIT_ELEBUYS_USER_INFO, { ...params });
  }

  // 象买网-商铺
  // 商铺营收
  @observable shopRevenueList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  @action async getShopRevenueList(params) {
    const { data } = await httpClient.get(operate.GET_SHOP_REVENUE_LIST, {
      params,
    });
    if (data) {
      this.shopRevenueList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }

  // 商铺列表
  @observable shopList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  @action async getShopList(params) {
    const { data } = await httpClient.post(operate.GET_SHOP_LIST, {
      ...params,
    });
    if (data) {
      this.shopList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }

  @observable shopInfo = {};
  @action async getShopInfo(params) {
    const { data } = await httpClient.post(operate.GET_SHOP_DETAIL, {
      ...params,
    });
    if (data) {
      this.shopInfo = data;
    }
  }

  @action resetShopInfo() {
    this.shopInfo = {};
  }

  // 更改商铺营业状态（本期不做）
  @action async changeShopState(params) {
    return await httpClient.post(operate.ELE_SHOP_CHANGE_STATE, { ...params });
  }

  @action async updateShopInfo(params) {
    return params.isAdd
      ? this.addShop(params)
      : httpClient.post(operate.EDIT_SHOP, { ...params });
  }

  @action async addShop(params) {
    const { data } = await httpClient.post(operate.ADD_SHOP, { ...params });
    console.log("add", data);
    return data;
  }

  // 搜索已进行企业认证账号的企业列表
  @observable shopAuthRecordList = [];
  @action async searchShopAuthRecordList(params) {
    const { data } = await httpClient.get(operate.GET_SUPPLIER_LIST_BY_NAME, {
      params,
    });
    if (data) {
      this.shopAuthRecordList = data;
    } else {
      this.shopAuthRecordList = [];
    }
  }

  //校验卖家会员账号
  @action async checkAccount(params) {
    const data = await httpClient.get(operate.CHECK_SUPPLIER_ACCOUNT_ELEMENT, {
      params,
    });
    return data;
  }

  // 商铺类型列表
  @observable shopTypeList = [];
  @action async getShopTypeList(params) {
    const { data } = await httpClient.get(operate.GET_SHOP_TYPE_LIST, {
      params,
    });
    if (data) {
      this.shopTypeList = data;
    }
  }

  @action async updateShopType(params) {
    return params.isAdd
      ? httpClient.post(operate.ADD_SHOP_TYPE, { ...params })
      : httpClient.post(operate.EDIT_SHOP_TYPE, { ...params });
  }

  @action delShopType(params) {
    return httpClient.post(operate.DEL_SHOP_TYPE, { ...params });
  }

  // @observable authInfo = {}
  // @action async getAuthInfo(params) {
  //   const { data } = await httpClient.get(operate.GET_ELEBUYS_AUTH_INFO, { params })
  //   if(data) {
  //     this.authInfo = data
  //   }
  // }

  // // 删除/置顶信息。0取消置顶 1置顶 3删除
  // @action async delInfo(params) {
  //   switch(params.modalType) {
  //     case 0: httpClient.post(operate.SET_TOP_LIYE_INFO, { itemsId: params.itemsId, istop: params.modalType }); break
  //     case 1: httpClient.post(operate.SET_TOP_LIYE_INFO, { itemsId: params.itemsId, istop: params.modalType }); break;
  //     case 3: httpClient.post(operate.DEL_LIYE_INFO, {...params}); break;
  //   }
  // }

  // // 设置标签类型
  // @action setLabelType(params) {
  //   return httpClient.post(operate.SET_LABEL_TYPE, {...params})
  // }

  // // 重置详情
  // @action resetInfoDetail() {
  //   this.infoDetailInfo = {}
  // }

  // // 新增信息类型
  // @action async updateInfoType(params) {
  //   return params.isAdd
  //     ? httpClient.post(operate.ADD_INFO_TYPE, {...params})
  //     : httpClient.post(operate.EDIT_INFO_TYPE, {...params})
  // }

  // // 更改信息类型启用状态&删除
  // @action async changeInfoTypeState(params) {
  //   return await httpClient.post(operate.CHANGE_INFO_TYPE, { ...params });
  // }

  // ----象店管理---- //
  // 象店列表
  @action async getElestoreList(params) {
    try {
      const { data } = await httpClient.post(operate.GET_ELESTORE_LIST, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 认证会员列表
  @action async getCertMemberList(params) {
    try {
      const { data } = await httpClient.post(operate.GET_CERT_MEMBER_LIST, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 新增象店
  @action async addElestore(params) {
    try {
      const { data } = await httpClient.post(operate.ADD_ELESTORE, {
        ...params,
      });
      return data;
    } catch (error) {
      return { err: true, errMsg: error.message };
    }
  }

  // 获取店长列表
  @action async getElestoreManagerList(params) {
    try {
      const { data } = await httpClient.post(
        operate.GET_ELESTORE_MANAGER_LIST,
        { ...params }
      );
      return data;
    } catch (error) {
      return false;
    }
  }

  // 获取当前平台享金比例
  @action async getBonusPercent(params) {
    try {
      const { data } = await httpClient.get(operate.GET_SHARE_BONUS, {
        params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 修改当前平台享金比例
  @action async updatePlatformBonusPercent(params) {
    try {
      const { success } = await httpClient.post(operate.UPDATE_SHARE_BONUS, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 获取会员列表
  @action async getVipList(params) {
    try {
      const { data } = await httpClient.post(operate.GET_ELEBUYS_USER_LIST, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 修改会员等级
  @action async updateVipLevel(params) {
    try {
      const { success } = await httpClient.post(operate.UPDATE_VIP_LEVEL, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 修改合伙人等级
  @action async updatePartnerLevel(params) {
    try {
      const { success } = await httpClient.post(operate.UPDATE_PARTNER_LEVEL, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 查询会员等级信息
  @action async getMemberInfo(params) {
    try {
      const data = await httpClient.get(operate.GET_MEMBER_INFO, { params });
      return data;
    } catch (error) {
      return false;
    }
  }
  // 查询会员等级信息
  @action async searchMemberLevel(params) {
    try {
      const data = await httpClient.get(operate.SEARCH_MEMBER_LEVEL, {
        params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
  // 查询各个会员等级信息
  @action async searchLevel(params) {
    try {
      const data = await httpClient.get(operate.SEARCH_MEMBER_LEVEL_INFO);
      return data;
    } catch (error) {
      return false;
    }
  }
  // 修改会员等级信息
  @action async editMemberLevel(params) {
    try {
      const data = await httpClient.post(operate.CHANGE_MEMBER_LEVEL, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
  // 新修改会员等级信息
  @action async editMemberLevelNew(params) {
    try {
      const data = await httpClient.post(operate.CHANGE_MEMBER_LEVEL_NEW, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
  // 提前续约
  @action async appointmentTaskCreate(params) {
    try {
      const data = await httpClient.post(operate.APPOINTMENT_TASK_CREATE, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
  // plus修改记录
  @action async getPlusRecordList(params) {
    try {
      const { data } = await httpClient.post(operate.PLUS_RECORD_LIST, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
  // 预约任务修改记录
  @action async appointmentTaskPage(params) {
    try {
      const { data } = await httpClient.post(operate.APPOINTMENT_TASK_PAGE, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
  // 取消预约任务
  @action async appointmentTaskCancel(params) {
    try {
      const res = await httpClient.post(operate.APPOINTMENT_TASK_CANCEL, {
        ...params,
      });
      return res;
    } catch (error) {
      return false;
    }
  }
  // 企业认证信息
  @action async getCompanyAuthInfo(params) {
    try {
      const { data } = await httpClient.get(operate.GET_CERT_INFO, { params });
      data && (this.authInfo = data);
      return data;
    } catch (error) {
      return false;
    }
  }

  @observable supplierDetailInfo = {};
  // 获取供应商详情
  @action async getSupplierDetail(params) {
    try {
      const { data } = await httpClient.get(supplier.GET_SUPPLIER_DETAIL, {
        params,
      });
      this.supplierDetailInfo = data;
      return data;
    } catch (error) {
      return false;
    }
  }

  @observable userTagList = [];
  // 获取用户标签
  @action async getUserTagList() {
    try {
      const { success, data } = await httpClient.get(operate.GET_USER_TAG, {});
      success && (this.userTagList = data);
      return true;
    } catch (error) {
      return false;
    }
  }

  // 设置用户标签
  @action async setUserTag(params) {
    try {
      const { success } = await httpClient.post(operate.SET_USER_TAG, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 获取业务员列表
  @action async getPromoterList(params) {
    try {
      const { data } = await httpClient.post(operate.GET_PROMOTER_LIST, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 添加业务员
  @action async addPromoter(params) {
    try {
      const { success } = await httpClient.post(operate.ADD_PROMOTER, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 删除业务员
  @action async delPromoter(params) {
    try {
      const { success } = await httpClient.post(operate.DELETE_PROMOTER, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 设置业务员
  @action async setPromoter(params) {
    try {
      const { success } = await httpClient.post(operate.SET_PROMOTER, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 添加用户
  @action async addUser(params) {
    try {
      const { success } = await httpClient.post(operate.ADD_USER, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 合伙人申请列表
  @action async getPartnerApplyList(params) {
    try {
      const { data } = await httpClient.post(operate.GET_PARTNER_LIST, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 合伙人标记
  @action async remarkPartner(params) {
    try {
      const { success } = await httpClient.post(operate.REMARK_PARTNER, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  //获取3.0新价格的接口
  @action async getNewThreePrice(params) {
    try {
      const data = await httpClient.post(operate.GET_NEW_THREE_PRICE, {
        ...params,
      });
      return data;
    } catch (err) {
      return false;
    }
  }

  //3.0移除会员等级，改为普通会员
  @action async closeAccount(params) {
    try {
      const data = await httpClient.get(operate.CLOSE_ACCOUNT, {
        params,
      });
      return data;
    } catch (err) {
      return false;
    }
  }

  // 服务组列表
  @action async getServiceGroupDrop(params) {
    return await httpClient.post(operate.GET_SERVICE_GROUP_DROP, { ...params });
  }

  // 分配服务组
  @action async allocateServiceGroup(params) {
    return await httpClient.post(operate.ALLOCATE_SERVICE_GROUP, { ...params });
  }

  // 获取会员档案列表
  @action async getRecordList(params) {
    try {
      const { data } = await httpClient.post(operate.GET_ELEBUYS_RECORD_LIST, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
  @observable userRecordList = [];
  // 获取客户成功，销售列表
  @action async getUserRecordList(params) {
    try {
      const {success, data } = await httpClient.post(operate.GET_USER_RECORD_LIST, {
        ...params,
      });
      success && (this.userRecordList = data);
      return true;
    } catch (error) {
      return false;
    }
  }

   // 会员档案编辑
   @action async getRecordEdit(params) {
    try {
      const { success } = await httpClient.post(operate.GET_USER_RECORD_EDIT, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

   // 获取会员档案详情
   @action async getRecordDetail(params) {
    try {
      const { data } = await httpClient.post(operate.GET_USER_RECORD_DETAIL, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
    // 获取交易中心列表
    @action async getTradeList(params) {
      try {
        const { data } = await httpClient.post(operate.GET_USER_TRADE_LIST, {
          ...params,
        });
        return data;
      } catch (error) {
        return false;
      }
    }

      // 获取交易中心详情
   @action async getTradeDetail(params) {
    try {
      const { data } = await httpClient.post(operate.GET_USER_TRADE_DETAIL, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }

      // 交易中心作废
      @action async getTradeCancel(params) {
        try {
          const res = await httpClient.post(operate.GET_USER_TRADE_CANCEL, {
            ...params,
          });
          return res;
        } catch (error) {
          return false;
        }
      }

      // 交易中心去支付
      @action async getTradePay(params) {
        try {
          const res = await httpClient.post(operate.GET_USER_TRADE_PAY, {
            ...params,
          });
          return res;
        } catch (error) {
          return false;
        }
      }
    // 交易中心新增
    @action async getTradeAdd(params) {
      try {
        const res = await httpClient.post(operate.GET_USER_TRADE_ADD, {
          ...params,
        });
        return res;
      } catch (error) {
        return false;
      }
    }
     // 查询企业名称
     @action async getTradeCompanyList(params) {
      try {
        const res = await httpClient.post(operate.GET_USER_COMPANY_LIST, {
          ...params,
        });
        return res;
      } catch (error) {
        return false;
      }
    }
      // 查询企业名称
      @action async getMemberCompanyList(params) {
        try {
          const res = await httpClient.post(operate.GET_MEMBER_USER_LIST, {
            ...params,
          });
          return res;
        } catch (error) {
          return false;
        }
      }
      // 交易中心详情
      @action async getTradeDetail(params) {
        try {
          const { data } = await httpClient.post(operate.GET_USER_TRADE_DETAIL, {
            ...params,
          });
          return data;
        } catch (error) {
          return false;
        }
      }
      @observable memberVersionList = [];
      // 获取会员版本
      @action async getMemberVersionList(params) {
        try {
          const {success, data } = await httpClient.post(operate.GET_MEMBER_VERSION, {
            ...params,
          });
          success && (this.memberVersionList = data);
          return true;
        } catch (error) {
          return false;
        }
      }
  // 获取地址
  @action async getArea(params) {
    try {
      const res= await httpClient.post(operate.GET_AREA_AREAS, {
        ...params,
      });
      return res;
    } catch (error) {
      return false;
    }
  }
    // 是否可增购
    @action async isCheckPermission(params) {
      try {
        const res= await httpClient.post(operate.CHECK_PERMISSION, {
          ...params,
        });
        return res;
      } catch (error) {
        return false;
      }
    }
}

export default new ElebuysOperateStore();
